<template>
    <div class=''>
		<v-snackbar
			top
			centered
      		elevation="24"
      		:color="colorType"
			:value="snackbar">
			{{ snackbarText }}
			<template v-slot:action="{ attrs }">
				<v-btn
                    color="pink"
                    text
                    v-bind="attrs"
                    @click="close"
                    >
                    {{$t('btn.closeBtn')}}
				</v-btn>
			</template>
		</v-snackbar>
    </div>
</template>

<script>
export default {
	model: {
		prop: 'snackbar',
		event: 'update:is-snackbar-sidebar-active',
	},
    computed: {
		snackbarText() {
			return this.$store.state.snackbar.snackbarText;
		},
		snackbar() {
			return this.$store.state.snackbar.snackbar;
		},
		colorType() {
			return this.$store.state.snackbar.colorType;
		},
    },
	methods: {
		close() {
			this.$store.commit("snackbar/CLOSE_SNACKBAR");
		}
	}
}
</script>

<style lang='scss' scoped>

</style>